import React from "react";

/**
 * Inline LabComplyx wordmark + dot cluster mark.
 * variant="dark" → for dark navy surfaces; variant="light" → for light surfaces.
 */
export default function BrandLogo({ variant = "dark", showTagline = false, className = "" }) {
  const onDark = variant === "dark";
  const labColor = onDark ? "text-white" : "text-[#1B3B6F]";
  const complyxColor = onDark ? "text-brand-teallight" : "text-brand-teal";
  const diamondBg = onDark ? "bg-white" : "bg-[#1B3B6F]";

  return (
    <span className={`inline-flex flex-col ${className}`}>
      <span className="inline-flex items-center gap-2">
        <span className="relative w-4 h-4 shrink-0" aria-hidden="true">
          <span className={`absolute left-1/2 top-0 -translate-x-1/2 w-[6px] h-[6px] rotate-45 rounded-[1px] ${diamondBg}`} />
          <span className="absolute bottom-0 left-0 w-[5px] h-[5px] rounded-full bg-brand-teallight" />
          <span className="absolute bottom-0 right-0 w-[5px] h-[5px] rounded-full bg-brand-teallight" />
        </span>
        <span className="text-xl font-extrabold tracking-tight leading-none">
          <span className={labColor}>Lab</span>
          <span className={complyxColor}>Complyx</span>
        </span>
      </span>
      {showTagline && (
        <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-teal">
          Smarter QA, Stronger Labs
        </span>
      )}
    </span>
  );
}